import React from 'react';
import {
  Col, Form, Input, Row, Select, Switch,
} from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { DashboardBannerEnum, DashboardBannerProps, GeneralSettingsFormProps } from '../types';
import { enumToOptionsArray } from '../../../../utils';

const prefix: keyof GeneralSettingsFormProps = 'dashboardBanner';

function DashboardBanner() {
  const form = useFormInstance<DashboardBannerProps>();
  const isVisibleWatch = Form.useWatch([prefix, 'visible'], form);

  return (
    // className="bordered-container"
    <div>
      <Row gutter={[12, 12]}>
        <Col span={24}>
          <Form.Item
            // label={index === 0 ? 'Label' : ''}
            name={[prefix, 'text']}
            rules={isVisibleWatch ? [{ required: true, message: 'Please enter banner text' }] : undefined}
          >
            <Input addonBefore="Banner Text" placeholder="Enter banner text" maxLength={400} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            // label="Type"
            label="Type"
            name={[prefix, 'type']}
            rules={isVisibleWatch ? [{ required: true }] : undefined}
          >
            <Select options={enumToOptionsArray(DashboardBannerEnum)} placeholder="Select type" />
          </Form.Item>
        </Col>
        <Col style={{ width: '100px' }}>
          <Form.Item
            // label={index === 0 ? 'Visible' : ''}
            label="Is Visible"
            name={[prefix, 'visible']}
            rules={[{ required: true }]}
          >
            <Switch
              checkedChildren="Visible"
              unCheckedChildren="Hidden"
              style={{ width: '76px' }}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}

export default DashboardBanner;
